import { Component, inject, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { ProfileService } from '../../../../services/profile-service';
import { CurrentUserService } from '../../../../services/current-user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-deactivate-account',
  imports: [],
  templateUrl: './deactivate-account.html',
  styleUrl: './deactivate-account.scss'
})
export class DeactivateAccount {
private router = inject(Router);
  private profileService = inject(ProfileService);
  private currentUserService = inject(CurrentUserService);

  loading = signal(false);
  apiError = signal('');


  onSave() {
    this.apiError.set('');
    this.loading.set(true);
    this.profileService
      .deactivateUser()
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: () => {
          console.log('Account deactivated successfully');
          this.currentUserService.logout();
          this.router.navigate(['/login']);
        },
        error: (err) => {
          console.error('Failed to deactivate account', err);
          this.apiError.set(
            err.messageEn || 'An unexpected error occurred while deactivating account. Please try again later.',
          );
        },
      });
  }

    private get profileBasePath(): string {
    return this.router.url.includes('/admin') ? '/admin/profile' : '/user/profile';
  }

  onCancel() {
    this.router.navigate([this.profileBasePath]);
  }
}